import { faInfoCircle, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown } from 'primereact/dropdown'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useToastr from '../../../../../hooks/useToastr'
import { Tooltip } from 'primereact/tooltip'
import {
  selectCertificateNumber,
  selectCertificateScheme,
  selectCopyPartyInformation,
  selectIsCertNumberOnMaxlength,
  selectHasExistingModels,
  updateCertDetailsFlatAttrList,
  updateCertDetailsFormValues,
  updateIsCertNumberOnMaxlength,
  updateProdDetailsModelList,
  updateHasExistingModels,
  selectProductOwner,
  selectCertDetailValues,
  updateModelList,
  selectHasEmptyProductStandardRow,
  selectStandardValue,
  selectCertDetailFormValues,
  updateHasCertificateProductStandard,
  updateSchemeEcmType,
  updateStandardOptions,
  updateStandardValues,
  updateSecondaryStandardValues,
  updateSelectedProductCategory,
  updateRecommendationStatus,
  updateSkipCoDecisioning,
  updateIsCo,
  updateHasIssueDate,
  selectIsCo,
  selectTestReportIssueDate,
  selectCopyState,
  updateCopyState,
  updateCopyPartyInformation,
  updateCertificateNumber,
  selectCertificateAction,
  selectCertDetailFlatAttribute,
  updateProductOwnerSearch,
} from '../../../../../features/createCertificate/createCertificateSlice'
import CertificateListService from '../../../../../services/CertificateListService'
import classes from './AddNewCertDetails.module.scss'
import './AddNewCertDetails.scss'
import UlAccordion from '../../../../../components/ul-accordion/UlAccordion'
import { AccordionTab } from 'primereact/accordion'
import clsx from 'clsx'
import AttrDisplayList from './dynamic-fields/AttrDisplayList'
import AttrDisplayTable from './dynamic-fields/AttrDisplayTable'
import AttrDisplaySingleSelectMultiple from './dynamic-fields/AttrDisplaySingleSelectMultiple'
import attributeComputeSlotTaken from './utils/attributeComputeSlotTaken'
import { groupBy } from 'lodash'
import getRenamedPanels from './utils/getRenamedPanels'
import { Checkbox } from 'primereact/checkbox'
import { v4 } from 'uuid'
import {
  getAttributeUniqueName,
  CertificateGroupEnum,
  trfUploadAllowedScheme,
  CNGSchemeWithIssuingBody,
  CNGSchemeName,
  CertificateGroup,
  CERTIFICATE_GROUPS,
  CERTIFICATE_SUMMARY_OF_MODIFICATIONS,
  CERTIFICATE_DRAFT_FIELDS,
} from '../../../../../utils/constants/certificate.constants'
import { objectToFormData } from '../../../../../utils/helpers/object.helpers'
import { getIsDynamicInputField } from './utils/GetDynamicInputField'
import CertificateModelSection from '../../certificate-model-section/CertificateModelSection'

const AddNewCertDetails = props => {
  const {
    schemeList,
    setIsValidStep,
    isEditCert,
    isModifyCert,
    hierarchyId,
    editData,
    hasRevisions,
    setIsDisableContinue,
    formValues,
    setFormValues,
    onContinue,
    certificateStatus,
    formAttributesWithError,
    setFormAttributesWithError,
    formValidityMessages,
    setFormValidityMessages,
    scrollIntoBlankRequiredElement,
    setScrollIntoBlankRequiredElement,
    currentStep,
    isCertificateSchemeUpdatable,
    setIsCertificateHaveStandard,
    selectedScheme,
    setSelectedScheme,
    isLastStepDirty,
    setIsLastStepDirty,
    isCopyCertificate,
    certificateId,
    certificateNumber,
    setCertificateNumber,
    isAutoGenerate,
    setIsAutoGenerate,
    isSavingCertificate,
    setIsModelInRowEditMode,
    setIsShowCertSchemeDropdown,
    isShowCertSchemeDropdown,
    setIsDisableDraftSave,
    certificateLoader,
  } = props

  const [attributeFlatList, setAttributeFlatList] = useState([])
  const [formDisplay, setFormDisplay] = useState([])
  const [isFetchingCertAttributes, setIsFetchingCertAttributes] = useState(false)
  const [isShowNoStandard, setIsShowNoStandard] = useState({
    isShow: false,
    message: '',
  })
  const [addDynamicField, setAddDynamicField] = useState(false)
  const [dropdownRef, setDropdownRef] = useState()
  const [productOwnerFilter, setProductOwnerFilter] = useState('')
  const [isFieldMounted, setIsFieldMounted] = useState(false)

  const dispatch = useDispatch()
  const copyCertificateNumber = useSelector(selectCertificateNumber)
  const copyPartyInformation = useSelector(selectCopyPartyInformation)
  const isCertNameOnMaxLength = useSelector(selectIsCertNumberOnMaxlength)
  const certificateScheme = useSelector(selectCertificateScheme)
  const hasExistingModels = useSelector(selectHasExistingModels)
  const productOwner = useSelector(selectProductOwner)
  const certDetails = useSelector(selectCertDetailValues)
  const hasEmptyProductRow = useSelector(selectHasEmptyProductStandardRow)
  const standardValues = useSelector(selectStandardValue)
  const certificateDetailFormValues = useSelector(selectCertDetailFormValues)
  const certFormDetailsValue = useSelector(selectCertDetailFormValues)
  const testReportIssueDate = useSelector(selectTestReportIssueDate)
  const [activeAccordionIndeces, setActiveAccordionIndeces] = useState([])
  const [generalInfoFields, setGeneralInfoFields] = useState([])
  const [certificateDraftFields, setCertificateDraftFields] = useState([])
  const [certifyFields, setCertifyFields] = useState([])
  const [partiesField, setPartiesField] = useState([])
  const [recommendFields, setRecommendFields] = useState([])
  const [decisionFields, setDecisionFields] = useState([])
  const [allRequiredFields, setAllRequiredFields] = useState([])
  const [skipCoDecision, setSkipCoDecision] = useState(false)
  const isCo = useSelector(selectIsCo)
  const copyState = useSelector(selectCopyState)
  const certificateAction = useSelector(selectCertificateAction)
  const certificateFlatAttributes = useSelector(selectCertDetailFlatAttribute)

  const certGroupToReset = ['C_QUESTIONS', 'D_RECOMMENDATION', 'E_CERTIFY']
  const fieldsForWithdraw = ['certificate_revisionNumber', 'certify_withdrawalDate']
  const PRODUCTS_EVAL_INSERTED_BLOCKS = 1
  const [selectedFile, setSelectedFile] = useState(null)
  const [isUploading, setIsUploading] = useState(false)
  const [disableAutoGenerate, setDisableAutoGenerate] = useState(false)
  const { showSuccess, showError } = useToastr()
  const [closeLookupSignal, setCloseLookupSignal] = useState(0)
  useEffect(() => {
    if (!selectedScheme) return

    for (const prop in formValidityMessages) {
      setFormAttributesWithError(formValidityMessages)

      if (formValidityMessages[prop]) setFormAttributesWithError(formValidityMessages)
    }
  }, [formValidityMessages, selectedScheme])

  const isValidValue = value => {
    if (Array.isArray(value)) {
      return value.length > 0 && value.every(isValidValue)
    }

    return value?.trim() && value !== 'Invalid date'
  }

  const validateFieldValue = fieldValue => {
    const isValid = fieldValue?.every(x => {
      if (Array.isArray(x.value)) {
        const length = x?.value?.length
        const lastElement = x?.value[length - 1]

        if (
          partiesField.includes(x?.field) &&
          length > 1 &&
          lastElement === '' &&
          x?.value?.slice(0, -1).some(isValidValue)
        ) {
          return true
        }

        if (x.value?.length > 0) {
          return x.value.every(isValidValue)
        }

        return false
      } else {
        return isValidValue(x.value)
      }
    })

    return isValid
  }

  const hasSemicolonInValue = (value, index = null) => {
    if (Array.isArray(value)) {
      if (typeof index !== 'number') {
        return value.some(item => typeof item === 'string' && item.includes(';'))
      }

      return typeof value[index] === 'string' && value[index].includes(';')
    }

    return typeof value === 'string' && value.includes(';')
  }

  const isSemicolonValidatedField = field => {
    const dataType = field?.data_type?.toLowerCase()
    const isListValues = Array.isArray(field?.list_values) && field.list_values.length > 0

    if (getIsDynamicInputField(selectedScheme, field?.attribute_unique_name)) {
      return true
    }

    if (dataType === 'date' || dataType === 'decimal' || dataType === 'integer') {
      return false
    }

    if (dataType === 'text') {
      if (isListValues) return false
      if (field?.is_allow_search) return false
      if (field?.is_search) return false
      if (field?.is_select_multiple) return false
      return true
    }

    return dataType === 'textarea'
  }

  useEffect(() => {
    const semicolonToken = 'cannot contain Semicolon'

    setFormValidityMessages(prevState => {
      let hasChanged = false
      const nextState = JSON.parse(JSON.stringify(prevState))

      Object.entries(nextState).forEach(([fieldName, message]) => {
        const fieldValue = formValues?.[fieldName]

        if (typeof message === 'string' && message.includes(semicolonToken)) {
          if (!hasSemicolonInValue(fieldValue)) {
            nextState[fieldName] = ''
            hasChanged = true
          }

          return
        }

        if (Array.isArray(message)) {
          const updatedMessages = [...message]
          let fieldChanged = false

          updatedMessages.forEach((item, index) => {
            if (
              typeof item === 'string' &&
              item.includes(semicolonToken) &&
              !hasSemicolonInValue(fieldValue, index)
            ) {
              updatedMessages[index] = ''
              fieldChanged = true
            }
          })

          if (fieldChanged) {
            nextState[fieldName] = updatedMessages
            hasChanged = true
          }
        }
      })

      return hasChanged ? nextState : prevState
    })
  }, [formValues, setFormValidityMessages])

  const validateInput = (field, element, valueFromArray = null) => {
    const errorClassNameInput = classes['certDetails-error-input']

    const fieldDetails = formDisplay
      .flatMap(f => f.cert_attributes)
      .find(x => x.attribute_unique_name === field)

    const isForWithdraw =
      fieldDetails?.display !== 'N' &&
      fieldsForWithdraw.includes(fieldDetails?.attribute_unique_name) &&
      certificateAction.isWithdraw

    if (fieldDetails?.is_required || isForWithdraw) {
      const fieldName = fieldDetails?.attribute_unique_name
      let currentValue = valueFromArray ?? certificateDetailFormValues?.[field]
      currentValue =
        isAutoGenerate && fieldName === 'certificate_certificateName'
          ? certificateNumber
          : currentValue

      if (!element) {
        element = document.getElementById(`certDetails-${fieldDetails?.data_group}`)
        element = element?.querySelector(`#input-${fieldName}`)
      }

      if (fieldDetails?.data_type.toLowerCase() === 'date') {
        element = element?.querySelector('.dynamic-field-date-div')
      } else if (fieldDetails?.is_select_multiple) {
        element = element?.querySelector('.p-multiselect')
      } else if (getIsDynamicInputField(selectedScheme, fieldName)) {
        element = element?.querySelector('.dynamic-autocomplete-div')
      } else if (fieldDetails?.list_values?.length > 0) {
        element = element?.querySelector('.p-inputwrapper')
      } else if (fieldDetails?.data_group !== '') {
        element = element?.querySelector('input.p-inputtext')
      } else if (fieldDetails?.is_allow_search) {
        element = element?.querySelector('.p-inputwrapper')
      }

      let isValid = false
      if (Array.isArray(currentValue)) {
        /**
         * currentValue in initial state is []
         * adding a new row will push an empty string
         * but the result is inconsistent [""] should be ["",""]
         * use formDisplay to get the actual count of row
         */
        const currentFormDisplay = formDisplay
          .flatMap(f => f.attributesDisplay)
          .filter(
            attr => (attr.type === 'list' || attr.type === 'table') && Array.isArray(attr.attribute)
          )
          .flatMap(attr => attr.attribute)
          .filter(item => item.attribute_unique_name === field)

        // set for initial inputs without clicking add button
        if (currentFormDisplay.length !== currentValue.length) {
          currentValue = [...currentValue, '']
        } else if (currentFormDisplay.length == 0) currentValue = ['']

        const lastElement = currentValue[currentValue.length - 1]
        if (
          partiesField.includes(fieldDetails?.attribute_unique_name) &&
          currentValue.length > 1 &&
          lastElement === '' &&
          currentValue.slice(0, -1).some(isValidValue)
        )
          return true
        else {
          currentValue.forEach((value, index) => {
            setTimeout(() => {
              validateInput(field, document.getElementById(`certDetails-${field}-${index}`), value)
            })
          })
          return
        }
      } else isValid = isValidValue(currentValue)

      if (isForWithdraw) isValid = handleWithdraw(field)

      if (!isValid) element?.classList.add(errorClassNameInput)
      else element?.classList.remove(errorClassNameInput)
    }
  }

  useEffect(() => {
    if (certFormDetailsValue == null) return
    setFormValues(prevState => {
      const newState = {
        ...prevState,
        [getAttributeUniqueName(CertificateGroupEnum.Certificate, 'testReportIssueDate')]:
          certificateDetailFormValues[
            getAttributeUniqueName(CertificateGroupEnum.Certificate, 'testReportIssueDate')
          ],
      }

      return newState
    })
  }, [testReportIssueDate])

  useEffect(() => {
    if (isEditCert || isModifyCert || isLastStepDirty) {
      if (formAttributesWithError) {
        Object.entries(formAttributesWithError).forEach(field => {
          const getElement = document.getElementById(`certDetails-${field[0]}`)
          validateInput(field[0], getElement)
        })
      }

      if (scrollIntoBlankRequiredElement && scrollIntoBlankRequiredElement.length > 0) {
        const scrollIntoSingleElement = document.querySelector(
          `[id*="${scrollIntoBlankRequiredElement[0]}"]`
        )

        if (scrollIntoSingleElement) {
          scrollIntoSingleElement.scrollIntoView({
            behavior: 'smooth',
          })
        }

        setScrollIntoBlankRequiredElement(null)
      }
    }

    return () => {
      setScrollIntoBlankRequiredElement(null)
    }
  }, [
    scrollIntoBlankRequiredElement,
    setScrollIntoBlankRequiredElement,
    formAttributesWithError,
    hasEmptyProductRow,
    formDisplay,
    certificateDetailFormValues,
    currentStep,
  ])

  useEffect(() => {
    setSelectedScheme(certificateScheme)
    if (certificateScheme) {
      setIsDisableContinue(true)
      setIsDisableDraftSave(true)
      setIsShowCertSchemeDropdown(false)
      setIsFetchingCertAttributes(true)
      getCertificateAttributes(certificateScheme)
    } else {
      setIsShowCertSchemeDropdown(true)
    }
  }, [certificateScheme])

  useEffect(() => {
    if (!selectedScheme || selectedScheme == '') return

    const genInfoRequiredValueFields = generalInfoFields.map(field => {
      return {
        field: field,
        value:
          isAutoGenerate && field === 'certificate_certificateName'
            ? certificateNumber
            : formValues?.[field],
      }
    })
    const isContinueEnable = validateFieldValue(genInfoRequiredValueFields)

    const draftFieldValues = certificateDraftFields.map(field => {
      return {
        field: field,
        value:
          isAutoGenerate && field === 'certificate_certificateName'
            ? certificateNumber
            : formValues?.[field],
      }
    })
    const isSaveDraftEnable = validateFieldValue(draftFieldValues)

    const allRequiredValueFields = allRequiredFields.map(field => {
      return {
        field: field,
        value:
          isAutoGenerate && field === 'certificate_certificateName'
            ? certificateNumber
            : formValues?.[field],
      }
    })

    const isAllRequiredValid = validateFieldValue(allRequiredValueFields)
    const isValidForWithdraw = validateWitdrawFields()

    const semicolonToken = 'cannot contain Semicolon'
    const hasSemicolonErrorFromValues = attributeFlatList.some(field => {
      if (!isSemicolonValidatedField(field)) return false
      return hasSemicolonInValue(formValues?.[field.attribute_unique_name])
    })

    const hasSemicolonErrorFromMessages = Object.entries(formValidityMessages).some(
      ([fieldName, message]) => {
        const fieldValue = formValues?.[fieldName]

        if (typeof message === 'string' && message.includes(semicolonToken)) {
          return hasSemicolonInValue(fieldValue)
        }

        if (Array.isArray(message)) {
          return message.some(
            (item, index) =>
              typeof item === 'string' &&
              item.includes(semicolonToken) &&
              hasSemicolonInValue(fieldValue, index)
          )
        }

        return false
      }
    )

    const hasSemicolonError = hasSemicolonErrorFromValues || hasSemicolonErrorFromMessages

    setIsDisableContinue(!isContinueEnable || hasSemicolonError)
    setIsDisableDraftSave(!isSaveDraftEnable || hasSemicolonError)
    setIsValidStep(prevState => {
      let newState = JSON.parse(JSON.stringify(prevState))
      newState[3] = isAllRequiredValid && isValidForWithdraw && !hasSemicolonError
      return newState
    })
  }, [formValues, isAutoGenerate, formValidityMessages, attributeFlatList, selectedScheme])

  useEffect(() => {
    if (isShowNoStandard.isShow) setIsDisableContinue(true)
  }, [isShowNoStandard])

  const hasStandardCertificate = certificateAttributes => {
    if (!Array.isArray(certificateAttributes) || certificateAttributes.length === 0) {
      return false
    }

    for (const element of certificateAttributes) {
      if (typeof element === 'object' && Array.isArray(element.cert_attributes)) {
        for (const attribute of element.cert_attributes) {
          if (
            attribute.attribute_unique_name ===
            getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard')
          ) {
            return true
          }
        }
      }
    }

    return false
  }

  const mappedDataForCopyCertificate = (
    editData,
    detailsAttributes,
    formValuesTemp,
    formDisplayTemp,
    formValidityMessagesTemp,
    section
  ) => {
    detailsAttributes.forEach(attribute => {
      if (
        attribute.attribute_unique_name === 'certificate_certificateName' ||
        attribute.attribute_unique_name === 'certificate_certificateType'
      )
        return

      const attrFromDb =
        section === 'party'
          ? editData.find(
              i =>
                i.attribute_unique_name ===
                getAttributeUniqueName(CertificateGroupEnum.PartyType, attribute.name)
            )
          : editData.find(i => i.attribute_unique_name === attribute.attribute_unique_name)

      if (!attrFromDb) return
      if (attribute.max_value !== '1') {
        if (attribute['attribute_unique_name'] === 'deliverable') {
          attribute['value'] = attrFromDb['value'].length > 0 && attrFromDb['value'][0].split(';')
        } else if (attribute.is_select_multiple) {
          attribute['value'] = attrFromDb?.value?.filter(x => x !== '')
        } else {
          attribute['value'] = attrFromDb['value']
        }
      } else if (attribute.max_value === '1' && attribute.data_group !== '') {
        attribute['value'] = attrFromDb['value']
      } else {
        attribute['value'] = attrFromDb['value'].length > 0 && attrFromDb['value'][0]
      }

      if (attribute['value']) {
        formValuesTemp[attribute['attribute_unique_name']] = attribute['value']
      }

      if ((attribute['is_required'] && attribute['value']) || !attribute['is_required']) {
        formValidityMessagesTemp[attribute['attribute_unique_name']] = ''
      }

      if (attribute.max_value !== '1' && !attribute.data_group) {
        formDisplayTemp.forEach(row => {
          if (row.cert_group === attribute['cert_group']) {
            row.attributesDisplay.forEach(display => {
              if (Array.isArray(display.attribute) && display.attribute.length > 0) {
                if (
                  display.attribute[0]['attribute_unique_name'] ===
                  attribute['attribute_unique_name']
                ) {
                  const fieldRowCount = attrFromDb['value'].length

                  const newAttr = JSON.parse(JSON.stringify(display.attribute[0]))
                  display.attribute = []
                  for (let count = 1; count <= fieldRowCount; count++) {
                    display.attribute.push(
                      Array.isArray(newAttr)
                        ? newAttr.map(item => ({
                            ...item,
                            uuid: v4(),
                          }))
                        : {
                            ...newAttr,
                            uuid: v4(),
                          }
                    )
                  }
                }
              }
            })
          }
        })
      } else if (attribute.max_value !== '1' && attribute.data_group) {
        formDisplayTemp.forEach(certGroupRow => {
          if (certGroupRow.cert_group === attribute['cert_group']) {
            certGroupRow.attributesDisplay.forEach(display => {
              if (
                Array.isArray(display.attribute) &&
                display.attribute.length > 0 &&
                display.attribute[0].length > 0
              ) {
                const foundField = display.attribute[0].find(
                  fieldColumn =>
                    fieldColumn['attribute_unique_name'] === attribute['attribute_unique_name']
                )

                if (foundField) {
                  const fieldRowCount = attrFromDb['value'].length

                  const newAttr = JSON.parse(JSON.stringify(display.attribute[0]))
                  display.attribute = []

                  for (let count = 1; count <= fieldRowCount; count++) {
                    display.attribute.push(newAttr)
                  }
                }
              }
            })
          }
        })
      }
    })
  }

  const getCertificateAttributes = async function (value, isChangeScheme = false) {
    const hierarchyIdValue = isModifyCert || isModifyCert === undefined ? '' : hierarchyId

    let isDecision = false
    let isCo = false

    const schemeDetail = await CertificateListService.getCertificateSchemeDetailByName(value)

    isDecision = schemeDetail?.data?.isDecision ? schemeDetail?.data?.isDecision : false
    isCo = schemeDetail?.data?.isCo ? schemeDetail?.data?.isCo : false

    dispatch(updateSchemeEcmType(schemeDetail?.data?.schemeEcmType))
    dispatch(updateIsCo(isCo))

    const result = await CertificateListService.getCertificateAttributes(
      value,
      hierarchyIdValue,
      isCo,
      isDecision
    )

    if (hasStandardCertificate(result)) {
      dispatch(updateHasCertificateProductStandard(true))
    } else {
      dispatch(updateHasCertificateProductStandard(false))
    }
    dispatch(updateStandardOptions(null))
    dispatch(updateStandardValues(null))

    if (result && Array.isArray(result) && result.length > 0) {
      let formValuesTemp = {}
      let formDisplayTemp = []
      let formValidityMessagesTemp = {}
      let attrFlatListTemp = []
      let listOfIssuingBody = result[0].cert_attributes?.find(
        attribute =>
          attribute.attribute_unique_name ===
          getAttributeUniqueName(CertificateGroupEnum.Certificate, 'issuingBody')
      )?.list_values

      let certNumber = await generateCertificateNumber(value, listOfIssuingBody?.[0])

      props.setIsCertificateHaveStandard(
        result[0].cert_attributes?.some(
          x =>
            x.attribute_unique_name ===
            getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard')
        )
      )

      result.forEach(certGroup => {
        let formDisplayUnderGroupTemp = []

        setAllRequiredFields(prevState => {
          const requiredFields = certGroup.cert_attributes
            .filter(attribute => attribute.is_required)
            .map(attribute => attribute.attribute_unique_name)

          return [...prevState, ...requiredFields]
        })

        if (certGroup.cert_group === CERTIFICATE_GROUPS.CERTIFICATE_TYPE) {
          setGeneralInfoFields(
            certGroup.cert_attributes
              .filter(attribute => attribute.is_required)
              .map(attribute => attribute.attribute_unique_name)
          )

          setCertificateDraftFields(
            certGroup.cert_attributes
              .filter(
                attribute =>
                  CERTIFICATE_DRAFT_FIELDS.includes(attribute.attribute_unique_name) &&
                  attribute.display !== 'N'
              )
              .map(attribute => attribute.attribute_unique_name)
          )
        }

        if (certGroup.cert_group === CERTIFICATE_GROUPS.CERTIFY_TYPE) {
          setCertifyFields(
            certGroup.cert_attributes.map(attribute => attribute.attribute_unique_name)
          )
        }

        if (certGroup.cert_group === CERTIFICATE_GROUPS.PARTY_TYPE) {
          setPartiesField(
            certGroup.cert_attributes.map(attribute => attribute.attribute_unique_name)
          )
        }

        if (certGroup.cert_group === CERTIFICATE_GROUPS.RECOMMENDATION_TYPE) {
          setRecommendFields(
            certGroup.cert_attributes.map(attribute => attribute.attribute_unique_name)
          )
        }

        if (certGroup.cert_group === CERTIFICATE_GROUPS.QUESTION_TYPE) {
          setDecisionFields(
            certGroup.cert_attributes.map(attribute => attribute.attribute_unique_name)
          )
        }

        certGroup.cert_attributes.forEach((attribute, index) => {
          let attributeFlat = JSON.parse(JSON.stringify(attribute))
          attributeFlat['cert_group'] = certGroup.cert_group
          attributeFlat['value'] = null
          attrFlatListTemp.push(attributeFlat)

          formValidityMessagesTemp[attribute.attribute_unique_name] =
            attribute.is_required && !attribute.default_value
              ? attribute.display_name + ' is required.'
              : ''

          if (attribute.is_select_multiple || attribute.data_group || attribute.max_value !== '1') {
            formValuesTemp[attribute.attribute_unique_name] = attribute.default_value
              ? [attribute.default_value]
              : []
          } else {
            formValuesTemp[attribute.attribute_unique_name] = attribute.default_value
          }

          setDisableAutoGenerate(!certNumber ? true : false)
          handleAutoGenerate(!copyState.certificateNumber && !!certNumber)

          if (certNumber) {
            formValidityMessagesTemp[
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateName')
            ] = ''
          }

          const lastDisplayItem = formDisplayUnderGroupTemp[formDisplayUnderGroupTemp.length - 1]

          if (attribute.data_group && !attribute.is_select_multiple) {
            if (
              lastDisplayItem &&
              lastDisplayItem.type === 'table' &&
              Array.isArray(lastDisplayItem.attribute) &&
              Array.isArray(lastDisplayItem.attribute[0]) &&
              attribute.data_group === certGroup.cert_attributes[index - 1].data_group
            ) {
              lastDisplayItem.attribute[0].push(attribute)
            } else {
              formDisplayUnderGroupTemp.push({
                attribute: [[attribute]],
                type: 'table',
                data_group: attribute.data_group,
              })
            }
          } else {
            if (attribute.max_value !== '1') {
              if (!attribute.is_select_multiple) {
                formDisplayUnderGroupTemp.push({
                  attribute: [
                    {
                      ...attribute,
                      uuid: v4(),
                    },
                  ],
                  type: 'list',
                })
              } else {
                formDisplayUnderGroupTemp.push({
                  attribute: attribute,
                  type: 'selectmultiple',
                })
              }
            } else {
              formDisplayUnderGroupTemp.push({
                attribute: attribute,
                type: 'single',
              })
            }
          }
        })

        formDisplayTemp.push({
          ...certGroup,
          attributesDisplay: formDisplayUnderGroupTemp,
        })
      })

      if (isCopyCertificate) {
        const detailsAttributes = attrFlatListTemp
          .filter(a => a.cert_group === CERTIFICATE_GROUPS.CERTIFICATE_TYPE)
          .map(a => a)

        const certificateData = editData.filter(
          e =>
            detailsAttributes.map(a => a.attribute_unique_name).includes(e.attribute_unique_name) &&
            e.value?.length > 0
        )

        const partyAttributes = attrFlatListTemp
          .filter(a => a.cert_group === CERTIFICATE_GROUPS.PARTY_TYPE)
          .map(a => a)

        const partiesData = editData.filter(
          e =>
            partyAttributes
              .map(a => getAttributeUniqueName(CertificateGroupEnum.PartyType, a.name))
              .includes(e.attribute_unique_name) && e.value?.length > 0
        )

        //CERTIFICATE SCHEME
        if (copyState.certificateScheme) {
          certificateData?.forEach(data => {
            if (
              data['attribute_unique_name'].includes(
                'certificate_certificateName',
                'certificate_certificateType'
              )
            )
              return

            const certificateAttribute = attrFlatListTemp.find(
              a =>
                a.cert_group === CERTIFICATE_GROUPS.CERTIFICATE_TYPE &&
                a.attribute_unique_name === data.attribute_unique_name
            )

            if (certificateAttribute.max_value !== '1') {
              formValuesTemp[certificateAttribute.attribute_unique_name] = data.value
            } else {
              formValuesTemp[certificateAttribute.attribute_unique_name] = data.value[0]
            }
            formValidityMessagesTemp[certificateAttribute.attribute_unique_name] = ''
          })

          mappedDataForCopyCertificate(
            certificateData,
            detailsAttributes,
            formValuesTemp,
            formDisplayTemp,
            formValidityMessagesTemp,
            'scheme'
          )
        }

        // CERTIFICATE NUMBER
        if (copyState.certificateNumber) {
          certificateData?.forEach(data => {
            if (data['attribute_unique_name'] !== 'certificate_certificateName') return

            const certificateAttribute = attrFlatListTemp.find(
              a =>
                a.cert_group === CERTIFICATE_GROUPS.CERTIFICATE_TYPE &&
                a.attribute_unique_name === data.attribute_unique_name
            )

            if (certificateAttribute.max_value !== '1') {
              formValuesTemp[certificateAttribute.attribute_unique_name] = data.value
            } else {
              formValuesTemp[certificateAttribute.attribute_unique_name] = data.value[0]
            }
            formValidityMessagesTemp[certificateAttribute.attribute_unique_name] = ''
          })
        }

        // PARTY INFORMATION
        if (copyState.partyInformation) {
          partiesData?.forEach(data => {
            const partyAttribute = attrFlatListTemp.find(
              a =>
                getAttributeUniqueName(CertificateGroupEnum.PartyType, a.name) ===
                data.attribute_unique_name
            )

            if (partyAttribute.max_value !== '1') {
              formValuesTemp[partyAttribute.attribute_unique_name] = data.value
            } else {
              formValuesTemp[partyAttribute.attribute_unique_name] = data.value[0]
            }
            formValidityMessagesTemp[partyAttribute.attribute_unique_name] = ''
          })

          mappedDataForCopyCertificate(
            partiesData,
            partyAttributes,
            formValuesTemp,
            formDisplayTemp,
            formValidityMessagesTemp,
            'party'
          )
        }
      }

      if (isEditCert) {
        let attributeFlatListFromDbTemp = editData

        attrFlatListTemp.forEach(attribute => {
          if (
            isChangeScheme &&
            (attribute.attribute_unique_name ===
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateType') ||
              attribute.attribute_unique_name ===
                getAttributeUniqueName(CertificateGroupEnum.Certificate, 'issuingBody'))
          )
            return

          const attrFromDb = attributeFlatListFromDbTemp.find(
            i =>
              i.attribute_unique_name ===
              (attribute['cert_group'] === CERTIFICATE_GROUPS.PARTY_TYPE
                ? getAttributeUniqueName(CertificateGroupEnum.PartyType, attribute.name)
                : attribute['attribute_unique_name'])
          )

          if (!attrFromDb) return
          if (attribute.max_value !== '1') {
            if (attribute['attribute_unique_name'] === 'deliverable') {
              attribute['value'] =
                attrFromDb['value'].length > 0 && attrFromDb['value'][0].split(';')
            } else if (attribute.is_select_multiple) {
              attribute['value'] = attrFromDb?.value?.filter(x => x !== '')
            } else {
              attribute['value'] = attrFromDb['value']
            }
          } else if (attribute.max_value === '1' && attribute.data_group !== '') {
            attribute['value'] = attrFromDb['value']
          } else {
            attribute['value'] = attrFromDb['value'].length > 0 && attrFromDb['value'][0]
          }

          if (attribute['value']) {
            formValuesTemp[attribute['attribute_unique_name']] = attribute['value']
          }

          if ((attribute['is_required'] && attribute['value']) || !attribute['is_required']) {
            formValidityMessagesTemp[attribute['attribute_unique_name']] = ''
          }

          if (attribute.max_value !== '1' && !attribute.data_group) {
            formDisplayTemp.forEach(row => {
              if (row.cert_group === attribute['cert_group']) {
                row.attributesDisplay.forEach(display => {
                  if (Array.isArray(display.attribute) && display.attribute.length > 0) {
                    if (
                      display.attribute[0]['attribute_unique_name'] ===
                      attribute['attribute_unique_name']
                    ) {
                      const fieldRowCount = attrFromDb['value'].length

                      const newAttr = JSON.parse(JSON.stringify(display.attribute[0]))
                      display.attribute = []
                      for (let count = 1; count <= fieldRowCount; count++) {
                        display.attribute.push(
                          Array.isArray(newAttr)
                            ? newAttr.map(item => ({
                                ...item,
                                uuid: v4(),
                              }))
                            : {
                                ...newAttr,
                                uuid: v4(),
                              }
                        )
                      }
                    }
                  }
                })
              }
            })
          } else if (attribute.max_value !== '1' && attribute.data_group) {
            formDisplayTemp.forEach(certGroupRow => {
              if (certGroupRow.cert_group === attribute['cert_group']) {
                certGroupRow.attributesDisplay.forEach(display => {
                  if (
                    Array.isArray(display.attribute) &&
                    display.attribute.length > 0 &&
                    display.attribute[0].length > 0
                  ) {
                    const foundField = display.attribute[0].find(
                      fieldColumn =>
                        fieldColumn['attribute_unique_name'] === attribute['attribute_unique_name']
                    )

                    if (foundField) {
                      const fieldRowCount = attrFromDb['value'].length

                      const newAttr = JSON.parse(JSON.stringify(display.attribute[0]))
                      display.attribute = []

                      for (let count = 1; count <= fieldRowCount; count++) {
                        display.attribute.push(newAttr)
                      }
                    }
                  }
                })
              }
            })
          }

          if (certificateAction.isWithdraw) {
            fieldsForWithdraw.forEach(
              field => (formValidityMessagesTemp[field] = `${field} is required.`)
            )
          }
        })
      }

      if (isModifyCert) {
        attrFlatListTemp.forEach(attribute => {
          if (!certGroupToReset.includes(attribute['cert_group'])) return

          if (attribute.max_value === 'n' && attribute.data_group) {
            formDisplayTemp.forEach(row => {
              if (row.cert_group === attribute['cert_group']) {
                row.attributesDisplay.forEach(display => {
                  if (Array.isArray(display?.attribute) && display?.attribute?.length > 1) {
                    display.attribute = [
                      Array.isArray(display.attribute[0])
                        ? display.attribute[0].map(item => ({
                            ...item,
                            uuid: v4(),
                          }))
                        : {
                            ...display.attribute[0],
                            uuid: v4(),
                          },
                    ]
                  }
                })
              }
            })
          }
        })
      }
      setFormValues(formValuesTemp)
      dispatch(
        updateHasIssueDate(
          formValuesTemp[getAttributeUniqueName(CertificateGroupEnum.Certify, 'issueDate')]
            ? true
            : false
        )
      )
      dispatch(updateCertDetailsFormValues(formValuesTemp))
      setFormDisplay(formDisplayTemp)
      setFormValidityMessages(formValidityMessagesTemp)
      setAttributeFlatList(attrFlatListTemp)
      dispatch(updateCertDetailsFlatAttrList(attrFlatListTemp))
      dispatch(
        updateIsCertNumberOnMaxlength(
          formValuesTemp[
            getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateName')
          ]?.length >= 150
        )
      )
    } else {
      setFormValidityMessages({})
      setFormValues({})
      setFormDisplay([])
      setAttributeFlatList([])
      dispatch(updateCertDetailsFlatAttrList([]))
    }

    setIsFetchingCertAttributes(false)
  }

  const generateCertificateNumber = async function (certficateScheme, issuingBody = '') {
    if (!certficateScheme || isEditCert || isModifyCert || copyState?.certificateNumber) return

    // Check if the scheme exists in CNGSchemeName and map to its value
    const mappedScheme =
      CNGSchemeName.find(item => item.name === certficateScheme)?.value ?? certficateScheme

    const data = {
      certificateScheme: mappedScheme,
      issuingBody,
    }

    const result = await CertificateListService.generateCertficateNumber(data)

    const certNumber = result?.data?.number
    setCertificateNumber(certNumber)

    return certNumber
  }

  const handleAutoGenerate = async function (autoGenerate) {
    const certificateNameField = getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'certificateName'
    )

    setIsAutoGenerate(autoGenerate)
    if (autoGenerate) {
      setFormValues(prev => {
        const response = {
          ...prev,
          [certificateNameField]: '',
        }
        dispatch(updateCertDetailsFormValues(response))
        return response
      })

      setFormValidityMessages(prev => {
        const nextState = {
          ...prev,
        }

        if (
          typeof nextState[certificateNameField] === 'string' &&
          nextState[certificateNameField].includes('cannot contain Semicolon')
        ) {
          nextState[certificateNameField] = ''
        }

        return nextState
      })
    }
  }

  const onChangeScheme = async value => {
    setIsShowCertSchemeDropdown(false)
    setIsFetchingCertAttributes(true)
    setIsDisableContinue(true)
    setIsDisableDraftSave(true)
    setAllRequiredFields([])
    setGeneralInfoFields([])
    setPartiesField([])
    setIsLastStepDirty(false)
    await getCertificateAttributes(value, true)
    setSelectedScheme(value)
    setIsFieldMounted(false)
  }

  const onAddDynamicFieldMultiple = (certGroupIndex, attrIndex, row = null) => {
    let attributeType
    const type_identity = row[0]?.type_identity

    setFormDisplay(prevState => {
      let formDisplayTemp = JSON.parse(JSON.stringify(prevState))

      certGroupIndex = formDisplayTemp.findIndex(x => x.cert_group === type_identity)

      attributeType = formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].type

      const templateValue =
        formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].attribute[0]
      formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].attribute.push(
        Array.isArray(templateValue)
          ? templateValue
          : {
              ...templateValue,
              uuid: v4(),
            }
      )
      return formDisplayTemp
    })

    setFormValues(prevState => {
      let formValuesTemp = JSON.parse(JSON.stringify(prevState))
      if (attributeType === 'table' || attributeType === 'list') {
        row.forEach(x => {
          if (formValuesTemp[x.attribute_unique_name]?.length == 0)
            formValuesTemp[x.attribute_unique_name].push('')

          formValuesTemp[x.attribute_unique_name].push(x.default_value)
        })
      }

      dispatch(updateCertDetailsFormValues(formValuesTemp))
      return formValuesTemp
    })

    setAddDynamicField(true)
  }

  const onCopyDynamicFieldMultiple = (certGroupIndex, attrIndex, row = null, index) => {
    let attributeType
    const type_identity = row[0]?.type_identity
    const semicolonToken = 'cannot contain Semicolon'

    const isSemicolonValidatedField = field => {
      const dataType = field?.data_type?.toLowerCase()
      const isListValues = Array.isArray(field?.list_values) && field.list_values.length > 0

      if (dataType === 'date' || dataType === 'decimal' || dataType === 'integer') {
        return false
      }

      if (dataType === 'text') {
        if (isListValues) return false
        if (field?.is_allow_search) return false
        if (field?.is_search) return false
        if (field?.is_select_multiple) return false
        return true
      }

      return dataType === 'textarea'
    }

    setFormDisplay(prevState => {
      let formDisplayTemp = JSON.parse(JSON.stringify(prevState))
      certGroupIndex = formDisplayTemp.findIndex(x => x.cert_group === type_identity)
      attributeType = formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].type

      const templateValue =
        formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].attribute[0] ?? ''

      formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].attribute.push(
        Array.isArray(templateValue)
          ? templateValue
          : {
              ...templateValue,
              uuid: v4(),
            }
      )
      return formDisplayTemp
    })

    setFormValues(prevState => {
      let formValuesTemp = JSON.parse(JSON.stringify(prevState))
      if (attributeType === 'table' || attributeType === 'list') {
        row?.forEach(x => {
          const rowFormValues = formValuesTemp[x.attribute_unique_name]
          if (rowFormValues?.length == 0) rowFormValues.push('')
          const copiedValue = rowFormValues[index]
          const targetIndex = index + 1
          formValuesTemp[x.attribute_unique_name].splice(targetIndex, 0, copiedValue)
        })
      }

      dispatch(updateCertDetailsFormValues(formValuesTemp))
      return formValuesTemp
    })

    setFormValidityMessages(prevState => {
      let formValidityTemp = JSON.parse(JSON.stringify(prevState))
      const targetIndex = index + 1

      // Preserve Summary of Modifications row-level validation message on copy.
      const summaryMessages = formValidityTemp[CERTIFICATE_SUMMARY_OF_MODIFICATIONS]
      if (Array.isArray(summaryMessages)) {
        const summaryValidationMessage = summaryMessages[index] ?? ''
        summaryMessages.splice(targetIndex, 0, summaryValidationMessage)
      }

      // Apply semicolon validation state to copied row values for all eligible text fields.
      if (attributeType === 'table' || attributeType === 'list') {
        row?.forEach(field => {
          if (!isSemicolonValidatedField(field)) return

          const fieldName = field.attribute_unique_name
          const sourceValue = formValues?.[fieldName]?.[index]

          if (!(typeof sourceValue === 'string' && sourceValue.includes(';'))) {
            return
          }

          const semicolonMessage = `${field.display_name} attribute's value cannot contain Semicolon.`
          if (!Array.isArray(formValidityTemp[fieldName])) {
            formValidityTemp[fieldName] = []
          }

          formValidityTemp[fieldName][targetIndex] = semicolonMessage

          const currentValue = formValidityTemp[fieldName][index]
          if (
            typeof currentValue === 'string' &&
            currentValue.includes(semicolonToken) &&
            !formValidityTemp[fieldName][index]
          ) {
            formValidityTemp[fieldName][index] = semicolonMessage
          }
        })
      }

      return formValidityTemp
    })
    setAddDynamicField(true)
  }

  const onRemoveDynamicFieldMultiple = (
    attrId,
    certGroupIndex,
    attrIndex,
    removeIndex,
    row = null,
    rowUuid = null
  ) => {
    let attributeType
    const type_identity = row[0]?.type_identity

    setFormDisplay(prevState => {
      let formDisplayTemp = JSON.parse(JSON.stringify(prevState))
      certGroupIndex = formDisplayTemp.findIndex(x => x.cert_group === type_identity)
      attributeType = formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].type

      if (Boolean(rowUuid)) {
        formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].attribute = formDisplayTemp[
          certGroupIndex
        ].attributesDisplay[attrIndex].attribute.filter(item => item.uuid !== rowUuid)
      } else {
        formDisplayTemp[certGroupIndex].attributesDisplay[attrIndex].attribute.splice(
          removeIndex,
          1
        )
      }

      return formDisplayTemp
    })

    setFormValues(prevState => {
      let formValuesTemp = JSON.parse(JSON.stringify(prevState))
      if (attributeType === 'table') {
        const attributeNames = row.map(x => x.attribute_unique_name)

        attributeNames.forEach(x => {
          formValuesTemp[x]?.splice(removeIndex, 1)
        })
      } else {
        formValuesTemp[attrId]?.splice(removeIndex, 1)

        if (attrId === 'brand' && (isEditCert || isModifyCert)) {
          const brandField = formValuesTemp[attrId]

          const isAnyBrandFieldHasValue =
            brandField && brandField.length > 0 && brandField.some(x => x)

          setFormValidityMessages(prevState => {
            let formValidityTemp = JSON.parse(JSON.stringify(prevState))

            formValidityTemp[attrId] = isAnyBrandFieldHasValue ? '' : 'Trademark/Brand is required'

            return formValidityTemp
          })
        }
      }

      dispatch(updateCertDetailsFormValues(formValuesTemp))
      return formValuesTemp
    })

    setFormValidityMessages(prevState => {
      const formValidityTemp = JSON.parse(JSON.stringify(prevState))
      const fieldsToShift =
        attributeType === 'table' ? row?.map(x => x.attribute_unique_name) ?? [] : [attrId]

      fieldsToShift.forEach(fieldName => {
        if (Array.isArray(formValidityTemp[fieldName])) {
          formValidityTemp[fieldName].splice(removeIndex, 1)
        }
      })

      return formValidityTemp
    })
  }

  const showCertSchemeDropdown = () => {
    setIsShowCertSchemeDropdown(true)
    setSelectedScheme('')
    setIsDisableContinue(true)
    setIsDisableDraftSave(true)
    setIsLastStepDirty(false)
    setIsFieldMounted(false)
    dispatch(updateRecommendationStatus(true))
    dispatch(updateSkipCoDecisioning(false))
    dispatch(
      updateCopyState({
        certificateScheme: false,
        certificateNumber: false,
        models: false,
        partyInformation: false,
      })
    )
    dispatch(updateCopyPartyInformation(false))
    dispatch(updateCertificateNumber(null))
    setSkipCoDecision(false)
  }

  const getIfThereIsAnyDateValidityMessage = param => {
    for (const prop in formValidityMessages) {
      const message = formValidityMessages[prop]
      if (message && message === param) {
        return true
      }
    }

    return false
  }

  const modalHeader = (
    <>
      <h5 className={classes['modal-header']}>Change Product Owner PSN Confirmation</h5>
    </>
  )

  const footer = (
    <>
      <div className={classes['footer-container']}>
        <Button
          label="Yes"
          onClick={() => onChangeProductOwner()}
          className={`ul-button -app-primary`}
        />
        <Button
          label="No"
          onClick={() => onHideProductOwnerMessage()}
          className={`ul-button -medium default-cancel-button ${classes['btn-no']}`}
        />
      </div>
    </>
  )

  const onHideProductOwnerMessage = () => {
    if (productOwnerFilter !== '') dropdownRef.current.resetFilter()

    dispatch(updateHasExistingModels(false))
    dispatch(updateCertDetailsFormValues(certDetails.formValues))
  }

  const onChangeProductOwner = () => {
    const prevValue = certDetails.formValues

    let newState = {
      ...prevValue,
      [getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')]: productOwner,
    }

    dispatch(updateCertDetailsFormValues(newState))
    dispatch(updateHasExistingModels(false))
    dispatch(updateProdDetailsModelList([]))
    dispatch(updateModelList([]))

    setCloseLookupSignal(prev => prev + 1)
    dispatch(updateProductOwnerSearch(productOwner))
  }

  const shouldViewEditStanndardDetailsDisplay = attrDisplay =>
    attrDisplay.attribute.attribute_unique_name ===
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard') &&
    (isEditCert || isModifyCert)

  useEffect(() => {
    if (!Array.isArray(formDisplay)) return
    if (activeAccordionIndeces.length > 0) return // load current indeces on mount
    setActiveAccordionIndeces([...Array(formDisplay?.length ?? 0).keys()])
  }, [formDisplay])

  let formDisplayComputed = formDisplay.map(formItem => ({
    ...formItem,
    attributesDisplay: Object.entries(
      groupBy(
        formItem.attributesDisplay.map((srcAttribute, srcAttributeIndex) => ({
          ...srcAttribute,
          srcAttributeIndex, // need to preserve index for add and remove for table and list type
        })),
        item => {
          let attribute = item.attribute
          if (Array.isArray(item.attribute) && item.attribute.length > 0) {
            if (Array.isArray(item.attribute[0])) {
              attribute = item.attribute[0][0]
            } else {
              attribute = item.attribute[0]
            }
          }

          return [attribute.display_level_id, attribute.display_level_title].join('|')
        }
      )
    ).map(([key, attributesDisplay]) => {
      const [levelId, title] = key.split('|')
      return {
        title,
        levelId,
        items: attributeComputeSlotTaken(
          attributesDisplay,
          formItem.cert_group !== CERTIFICATE_GROUPS.QUESTION_TYPE
        ),
      }
    }),
  }))

  const insertProductsEvalBlock = formDisplayComputed => {
    const partyIndex = formDisplayComputed.findIndex(
      item => item.cert_group === CERTIFICATE_GROUPS.PARTY_TYPE
    )

    if (partyIndex !== -1) {
      formDisplayComputed.splice(partyIndex + 1, 0, {
        cert_group: CERTIFICATE_GROUPS.PRODUCTS_EVAL,
        cert_group_text: CERTIFICATE_GROUPS.PRODUCTS_EVAL_TEXT,
        attributesDisplay: [
          {
            levelId: CERTIFICATE_GROUPS.LEVEL_ID,
            items: [],
          },
        ],
      })
    }

    return formDisplayComputed
  }

  formDisplayComputed = insertProductsEvalBlock(formDisplayComputed)

  const renderSkipCoCheckbox = certGroup => {
    return (
      isCo &&
      certGroup.cert_group == CERTIFICATE_GROUPS.QUESTION_TYPE && (
        <div className={classes['checkbox-skip-co-container']}>
          <Checkbox
            inputId="cbSkipCo"
            checked={skipCoDecision}
            onChange={e => {
              const isChecked = e.checked
              setSkipCoDecision(isChecked)
              dispatch(updateSkipCoDecisioning(isChecked))

              setFormValues(prevState => {
                let formValuesTemp = JSON.parse(JSON.stringify(prevState))

                //Set Required field logic for Co Decision, if skip isChecked, field is not required
                setAllRequiredFields(prevState => {
                  let attributeList = certDetails.flatAttributeList.filter(
                    attribute => attribute.is_required
                  )
                  if (isChecked)
                    attributeList = attributeList.filter(
                      attribute => attribute.cert_group != CERTIFICATE_GROUPS.QUESTION_TYPE
                    )
                  const requiredFields = attributeList.map(
                    attribute => attribute.attribute_unique_name
                  )

                  return requiredFields
                })
                //collapse co decisioning panel
                if (isChecked) {
                  setActiveAccordionIndeces(prevState => {
                    const questionIndex = formDisplayComputed.findIndex(
                      group => group.cert_group == CERTIFICATE_GROUPS.QUESTION_TYPE
                    )
                    return prevState.filter(i => i !== questionIndex)
                  })
                }
                //Set or Clear Co Decision field values
                certDetails.flatAttributeList.forEach((attribute, index) => {
                  if (attribute.cert_group != CERTIFICATE_GROUPS.QUESTION_TYPE) return
                  processSkipCoFieldsValues(formValuesTemp, attribute, isChecked)
                })

                dispatch(updateCertDetailsFormValues(formValuesTemp))
                return formValuesTemp
              })
            }}
          ></Checkbox>
          <label htmlFor="cbSkipCo">Skip TC/CO Certificate Decisions</label>
        </div>
      )
    )
  }

  const processSkipCoFieldsValues = (formValuesTemp, attribute, isChecked) => {
    if (!isChecked) {
      //set to default values
      if (attribute.is_select_multiple || attribute.data_group || attribute.max_value !== '1') {
        formValuesTemp[attribute.attribute_unique_name] = attribute.default_value
          ? [attribute.default_value]
          : []
      } else {
        formValuesTemp[attribute.attribute_unique_name] = attribute.default_value
      }
    } else {
      //if is skip co, clear values
      if (attribute.is_select_multiple || attribute.data_group || attribute.max_value !== '1') {
        formValuesTemp[attribute.attribute_unique_name] = []
      } else {
        formValuesTemp[attribute.attribute_unique_name] = ''
      }
    }
  }

  const issuingBodyName = getAttributeUniqueName(CertificateGroupEnum.Certificate, 'issuingBody')

  const onIssuingBodyChange = useCallback(
    async event => {
      if (isModifyCert) return
      if (isEditCert) return
      if (copyState?.certificateNumber) return

      const listOfIssuingBody = attributeFlatList.find(
        attribute =>
          attribute.attribute_unique_name ===
          getAttributeUniqueName(CertificateGroupEnum.Certificate, 'issuingBody')
      )?.list_values

      const ceritifcateScheme =
        formValues[getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateType')]

      if (!CNGSchemeWithIssuingBody.includes(ceritifcateScheme)) return

      const issuingBody = listOfIssuingBody?.length > 1 ? event.value : ''

      const certNumber = await generateCertificateNumber(ceritifcateScheme, issuingBody)

      setDisableAutoGenerate(!certNumber ? true : false)
      handleAutoGenerate(!!certNumber)
    },
    [formValues]
  )

  const fieldChangeListener = {
    [issuingBodyName]: onIssuingBodyChange,
  }

  const onFileChange = event => {
    setSelectedFile(event.target.files[0])
  }
  const onFileUpload = async () => {
    if (!selectedFile || isUploading) return
    setIsUploading(true)
    let item = {
      certificateScheme: selectedScheme,
      file: selectedFile,
    }

    const formData = objectToFormData(item)
    CertificateListService.uploadTRFFile(formData).then(async response => {
      if (response?.isSuccess) {
        setFormValues(prevState => {
          let formValuesTemp = JSON.parse(JSON.stringify(prevState))

          const fromPdfDataAttributes = response.data.attributes
          const pdfDataDropdownAttributes = response.data.referenceAttributes
          certDetails.flatAttributeList.forEach((attribute, index) => {
            //Mapped Fields available from pdf
            const pdfDataAttribute = fromPdfDataAttributes.find(
              x => x.dataParamName == attribute.attribute_name
            )
            processTrfPdfFields(pdfDataAttribute, formValuesTemp, attribute)
            //Mapped Fields, dropdown specific from pdf
            const pdfDataAttributeDropdown = pdfDataDropdownAttributes.find(
              x => x.dataParamName == attribute.attribute_name
            )
            processTrfPdfDropdownFields(pdfDataAttributeDropdown, formValuesTemp, attribute)
          })

          dispatch(updateCertDetailsFormValues(formValuesTemp))
          return formValuesTemp
        })
        showSuccess(`Success!`, `Data from file has been extracted`)
      } else {
        showError('Error!', 'Encountered issue while extracting data from the file')
      }
      setIsUploading(false)
    })
  }
  const processTrfPdfFields = (pdfDataAttribute, formValuesTemp, attribute) => {
    if (!pdfDataAttribute) return
    if (!pdfDataAttribute.value) return

    if (Array.isArray(formValuesTemp[attribute.attribute_unique_name])) {
      formValuesTemp[attribute.attribute_unique_name] =
        pdfDataAttribute.value.indexOf(';') > -1
          ? pdfDataAttribute.value.split(';')
          : [pdfDataAttribute.value]
    } else {
      formValuesTemp[attribute.attribute_unique_name] = pdfDataAttribute.value
    }
  }
  const processTrfPdfDropdownFields = (pdfDataAttributeDropdown, formValuesTemp, attribute) => {
    if (!pdfDataAttributeDropdown) return
    const value = pdfDataAttributeDropdown?.value?.uniqueIdentifier
    if (!value) return

    if (Array.isArray(formValuesTemp[attribute.attribute_unique_name])) {
      formValuesTemp[attribute.attribute_unique_name] = [value]
    } else {
      formValuesTemp[attribute.attribute_unique_name] = value
    }

    trfStandardSpecificHandling(attribute, value)
    trfProductTypeSpecificHandling(attribute, value)
  }
  const trfStandardSpecificHandling = (attribute, value) => {
    if (attribute.attribute_unique_name == `${CertificateGroup.Certificate}standard`) {
      dispatch(updateStandardOptions(null))
      dispatch(updateStandardValues([value]))
      dispatch(updateSecondaryStandardValues([]))
    }
  }
  const trfProductTypeSpecificHandling = (attribute, value) => {
    if (
      attribute.attribute_unique_name == `${CertificateGroup.Certificate}certificationProductType`
    ) {
      dispatch(updateSelectedProductCategory(value))
    }
  }

  const isTrfUploadShow = () =>
    !isEditCert &&
    !isModifyCert &&
    selectedScheme &&
    trfUploadAllowedScheme.find(x => x == selectedScheme) != null

  const trfUpload = () => {
    return (
      isTrfUploadShow() && (
        <>
          <div className={`${classes['upload-trf-header']}`}>
            <div className={`${classes['title']}`}> Upload TRF Document</div>
            <div className={`${classes['info-icon']} tooltip-upload-trf-target`}>
              <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>
            </div>
            <Tooltip target={`.tooltip-upload-trf-target`} position="right">
              <div>
                TRF Documents expected are under the following standards 'IEC 62368-1:2018', 'IEC
                62368-1:2014', 'IEC 62133-2:2017', 'IEC 60950-1:2005', 'IEC 60335-1:2010', or any
                'IEC 60335-2-X'
              </div>
            </Tooltip>
            <div className={`${classes['allowed-type']}`}>
              Note: Allowed File Type:(PDF) | Data already entered may be replaced or lost on file
              upload
            </div>
          </div>
          <div className={`${classes['upload-trf-body']}`}>
            <input
              accept="application/pdf"
              type="file"
              onChange={onFileChange}
              className={`${classes['upload-input']}`}
            />
            <Button
              onClick={() => onFileUpload()}
              className={`ul-button -small ${classes['upload-trf-btn']}`}
              disabled={!selectedFile || isUploading}
            >
              {isUploading ? (
                <FontAwesomeIcon icon={faSpinner} size="sm" spin={isUploading} />
              ) : (
                'Upload'
              )}
            </Button>
          </div>
        </>
      )
    )
  }

  const handleWithdraw = field => {
    const flatAttributeValue = certificateFlatAttributes?.find(
      x => x.attribute_unique_name === field
    )

    if (flatAttributeValue?.display === 'N') return true

    const fieldValue = certificateDetailFormValues?.[field] ?? ''
    const isValidForWithdraw =
      field === 'certify_withdrawalDate'
        ? fieldValue
        : fieldValue?.toLowerCase() !== flatAttributeValue?.value?.toLowerCase()

    return isValidForWithdraw
  }

  const validateWitdrawFields = () => {
    if (!certificateAction.isWithdraw) return true

    return fieldsForWithdraw.every(withdraw => handleWithdraw(withdraw))
  }

  return (
    <>
      <div>
        <span>Enter certificate details below</span>
        <span className="text-red"> (* = Required field)</span>
      </div>

      {isShowCertSchemeDropdown && (
        <div className="select-cert-scheme-div">
          <span className="select-cert-scheme-label">*Certification Scheme</span>
          <span>
            <Dropdown
              inputId="dropdown"
              value={selectedScheme}
              options={schemeList}
              optionLabel="hierarchyValue"
              optionValue="hierarchyValue"
              placeholder="-- Click to type below --"
              filter
              onChange={e => onChangeScheme(e.value)}
            />
          </span>
        </div>
      )}

      {!isShowCertSchemeDropdown &&
        !isFetchingCertAttributes &&
        isCertificateSchemeUpdatable &&
        !isEditCert &&
        !isModifyCert && (
          <>
            <div className="change-cert-scheme-div">
              <span onClick={showCertSchemeDropdown} className="change-cert-scheme-btn text-blue">
                Change Certificate Scheme?
              </span>
            </div>
            {trfUpload()}
          </>
        )}

      {isShowNoStandard.isShow && (
        <div className={`${classes['no-standard-toast']}`}>
          <div className={`ul-grid__row text-center ${classes['no-standard-toast-message']}`}>
            <div classname="ul-grid__column -x5" style={{ marginLeft: '0.5rem' }}>
              <FontAwesomeIcon icon={faInfoCircle} size="xl" />
            </div>
            <div className="ul-grid__column -x90">{isShowNoStandard.message}</div>
            <div className={`ul-grid__column -x5 ${classes['no-standard-toast-icon-close']}`}>
              <span
                onClick={() => setIsShowNoStandard({ isShow: false, message: '' })}
                className={`${classes['no-standard-toast-icon-close']}`}
              >
                <FontAwesomeIcon icon={faTimes} />
              </span>
            </div>
          </div>
        </div>
      )}

      {isFetchingCertAttributes && certificateLoader('Fetching attributes...')}

      <br />
      <UlAccordion
        multiple
        activeIndex={activeAccordionIndeces}
        onTabChange={event => {
          setActiveAccordionIndeces(event.index)
        }}
      >
        {!isShowCertSchemeDropdown &&
          !isFetchingCertAttributes &&
          formDisplay &&
          Array.isArray(formDisplay) &&
          formDisplay.length > 0 &&
          formDisplayComputed.map((certGroup, certGroupIndex) => (
            <AccordionTab
              key={`formDisplay-accordion-${certGroupIndex}`}
              header={getRenamedPanels(certGroup.cert_group_text)}
            >
              {certGroup.cert_group_text === CERTIFICATE_GROUPS.PRODUCTS_EVAL_TEXT ? (
                <CertificateModelSection
                  isSavingCertificate={isSavingCertificate}
                  isEditCert={isEditCert}
                  isModifyCert={isModifyCert}
                  setFormValues={setFormValues}
                  certificateId={certificateId}
                  currentStep={currentStep}
                  setIsModelInRowEditMode={setIsModelInRowEditMode}
                  setFormValidityMessages={setFormValidityMessages}
                  hasRevisions={hasRevisions}
                />
              ) : (
                <>
                  {renderSkipCoCheckbox(certGroup)}
                  {certGroup.attributesDisplay.map(({ title, levelId, items }) => {
                    return (
                      <div
                        key={`${levelId}-${title}`}
                        className="add-new-cert-grouped-flds-container"
                      >
                        {Boolean(title) && (
                          <div className="add-new-cert-grouped-flds-hdr">
                            <span>{title}</span>
                          </div>
                        )}
                        <div className="add-new-cert-grouped-flds-inputs">
                          <div class="ul-grid__row -wrap">
                            {(items ?? []).map((attrDisplay, attrIndex) => {
                              const isAttributeArray =
                                Array.isArray(attrDisplay.attribute) &&
                                attrDisplay.attribute.length > 0
                              const attribute = isAttributeArray
                                ? attrDisplay.attribute[0]
                                : attrDisplay?.attribute
                              const hasExpirationDate =
                                (Array.isArray(attribute) &&
                                  (attribute ?? []).some(
                                    attr =>
                                      attr.attribute_unique_name ===
                                      getAttributeUniqueName(
                                        CertificateGroupEnum.Certify,
                                        'expiryDate'
                                      )
                                  )) ||
                                attribute?.attribute_unique_name ===
                                  getAttributeUniqueName(CertificateGroupEnum.Certify, 'expiryDate')
                              const validityMessage =
                                formValidityMessages[attribute?.attribute_unique_name]

                              const attrDefaultProps = {
                                attrDisplay,
                                attrIndex: attrDisplay.srcAttributeIndex,
                                attributeFlatList,
                                certGroupIndex,
                                formDisplay,
                                setFormValidityMessages,
                                formValidityMessages,
                                setFormValues,
                                setIsShowNoStandard,
                                formValues,
                                selectedScheme,
                                isShowNoStandard,
                                fieldChangeListener,
                                validityMessage,
                              }

                              return (
                                <>
                                  {attrDisplay?.withBreakLine && (
                                    <div className="ul-grid__column -x100" />
                                  )}

                                  {attribute?.display != 'N' && (
                                    <div
                                      id={`certDetails-${
                                        Array.isArray(attribute)
                                          ? attribute[0]?.data_group
                                          : attribute?.attribute_unique_name
                                      }`}
                                      className={clsx(
                                        'ul-grid__column -offset-5-desktop -x100-mobile dynamic-fld-div',
                                        attribute?.attribute_unique_name ===
                                          getAttributeUniqueName(
                                            CertificateGroupEnum.Certify,
                                            'comment'
                                          ) && '-x60 dynamic-fld-list',
                                        attrDisplay?.type === 'list' && 'dynamic-fld-list',
                                        attrDisplay?.type === 'table' && 'dynamic-fld-table',
                                        attrDisplay?.slotTaken
                                        // attribute?.attribute_unique_name === "comment"
                                        //   ? "-x60 dynamic-fld-list"
                                        //   : attrDisplay.type === "list"
                                        //   ? "-x30 dynamic-fld-list"
                                        //   : attrDisplay.type === "single" ||
                                        //     attrDisplay.type === "selectmultiple"
                                        //   ? "-x30"
                                        //   : "-x100 dynamic-fld-table"
                                      )}
                                      key={`dynamic-field-div${certGroupIndex}-${attrIndex}`}
                                    >
                                      {(() => {
                                        switch (attrDisplay.type) {
                                          case 'list':
                                            return (
                                              attrDisplay.attribute.length > 0 && (
                                                <AttrDisplayList
                                                  {...attrDefaultProps}
                                                  {...{
                                                    addDynamicField,
                                                    isEditCert,
                                                    isModifyCert,
                                                    hasRevisions,
                                                    onAddDynamicFieldMultiple,
                                                    onRemoveDynamicFieldMultiple,
                                                    certifyFields,
                                                    decisionFields,
                                                    recommendFields,
                                                    validityMessage,
                                                    isFieldMounted,
                                                    setIsFieldMounted,
                                                    closeLookupSignal,
                                                    onCopyDynamicFieldMultiple,
                                                  }}
                                                />
                                              )
                                            )
                                          case 'table':
                                            return (
                                              <AttrDisplayTable
                                                {...attrDefaultProps}
                                                {...{
                                                  onAddDynamicFieldMultiple,
                                                  onRemoveDynamicFieldMultiple,
                                                  isEditCert,
                                                  isModifyCert,
                                                  hasRevisions,
                                                  setFormDisplay,
                                                  certifyFields,
                                                  decisionFields,
                                                  recommendFields,
                                                  isFieldMounted,
                                                  setIsFieldMounted,
                                                  onCopyDynamicFieldMultiple,
                                                }}
                                              />
                                            )
                                          case 'selectmultiple':
                                          case 'single':
                                            return (
                                              <AttrDisplaySingleSelectMultiple
                                                {...attrDefaultProps}
                                                {...{
                                                  shouldViewEditStanndardDetailsDisplay,
                                                  onContinue,
                                                  formDisplay,
                                                  isEditCert,
                                                  isModifyCert,
                                                  hasRevisions,
                                                  setDropdownRef,
                                                  setProductOwnerFilter,
                                                  certificateStatus,
                                                  isCertNameOnMaxLength,
                                                  classes,
                                                  certifyFields,
                                                  decisionFields,
                                                  recommendFields,
                                                  isFieldMounted,
                                                  setIsFieldMounted,
                                                  disableAutoGenerate,
                                                  isAutoGenerate,
                                                  handleAutoGenerate,
                                                  closeLookupSignal,
                                                }}
                                              />
                                            )
                                          default:
                                            return <></>
                                        }
                                      })()}

                                      {validityMessage &&
                                        typeof validityMessage === 'object' &&
                                        validityMessage?.displayOnEffect && (
                                          <div
                                            className="text-red effect-error"
                                            style={{ marginTop: '5px' }}
                                          >
                                            {validityMessage?.value}
                                          </div>
                                        )}

                                      {hasExpirationDate &&
                                        getIfThereIsAnyDateValidityMessage(
                                          'Expiry Date must be greater than or equal to Issue Date'
                                        ) &&
                                        certGroup.cert_group_text === 'Certify' && (
                                          <div className="text-red" style={{ marginTop: '5px' }}>
                                            Expiry Date must be greater than or equal to Issue Date'
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </>
                              )
                            })}
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </>
              )}
            </AccordionTab>
          ))}
      </UlAccordion>
      <Dialog
        visible={hasExistingModels}
        header={modalHeader}
        footer={footer}
        style={{ width: '30vw' }}
        onHide={() => onHideProductOwnerMessage()}
        className={classes['psn-confirmation-container']}
      >
        <p className={classes['body-content']}>
          Changing the Product Owner PSN will automatically delete the selected model(s).
          <br />
          <br />
          Do you want to proceed?
        </p>
      </Dialog>
    </>
  )
}

export default AddNewCertDetails
